import dateFormat from "dateformat";

export const dateToStringFormat = (str: string, format: string) => {
  if (str === undefined || str === null || str === "N/A") {
    return "N/A";
  }

  return dateFormat(Date.parse(str), format);
};
